import React from "react";
import Navbar from "../components/sub-comp/Navbar";
import Footer from "../components/sub-comp/MainFooter";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";
import { Link } from "react-router-dom";

const StudentPortal = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="mid-desktop-page">
      <section className="py-16 bg-gradient-to-r from-custom-pink to-purple-800 text-white text-center">
        <h1 className="text-4xl font-bold">Student Portal</h1>
        <p className="mt-2 text-white/90">Access your student resources.</p>
      </section>
      <section className="container mx-auto px-4 py-12 max-w-2xl text-center">
        <div className="bg-white rounded-xl shadow p-8 text-gray-800">
          <p className="text-lg mb-6">The student portal is being prepared. In the meantime, use the links below for key resources.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/admissions" className="px-6 py-3 bg-custom-pink text-white rounded-lg hover:bg-purple-800 transition-colors font-medium">Apply for Admissions</Link>
            <Link to="/fees" className="px-6 py-3 border-2 border-custom-pink text-custom-pink rounded-lg hover:bg-custom-pink hover:text-white transition-colors font-medium">Fee Structure</Link>
            <Link to="/contact" className="px-6 py-3 border-2 border-gray-400 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors font-medium">Contact Us</Link>
          </div>
        </div>
      </section>
      </div>
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default StudentPortal;



